import React from 'react';

export const ripleyCard = 'Tarjeta Ripley';
export const chek = 'Chek';
const creditCard = 'Tarjeta de crédito';
export const debitCard = 'Tarjeta de débito';

export const OPTIONS_PAYMENT_METHODS = [
  {
    id: ripleyCard,
    name: ripleyCard,
  },
  {
    id: creditCard,
    name: creditCard,
  },
  {
    id: debitCard,
    name: debitCard,
  },
];

const chileBank = 'BANCO DE CHILE/EDWARD/CITIBANK/CREDICHILE';
const internationalBank = 'BANCO INTERNACIONAL';
const continentalBank = 'BANCO CONTINENTAL';
const stateBank = 'BANCO DEL ESTADO DE CHILE';
const scotiabank = 'SCOTIABANK SUD AMERICANO';
const bci = 'BANCO DE CREDITO E INVERSIONES';
const brasilBank = 'BANCO DO BRASIL S.A';
const centralBank = 'BANCO CENTRAL';
const bice = 'BANCO BICE';
const hsbc = 'HSBC BANK (CHILE)';
const bankOfAmerica = 'BANK OF AMERICA';
const santander = 'BANCO SANTANDER';
const outsideBank = 'BANCO EXTERIOR S.A';
const itau = 'BANCO ITAU/CORPBANCA';
const sudameris = 'SUDAMERIS';
const jpmorgan = 'JP MORGAN CHASEBANK N.A';
const americanExpress = 'BANCO AMERICAN EXPRESS BANK';
const argentinaBank = 'BANCO DE LA NACION ARGENTINA';
const security = 'BANCO SECURITY';
const falabella = 'BANCO FALABELLA';
const ripley = 'BANCO RIPLEY';
const consorcio = 'BANCO CONSORCIO';
const penta = 'BANCO PENTA';
const paris = 'BANCO PARIS';
const bbva = 'BANCO BBVA';
const desarrollo = 'BANCO DEL DESARROLLO';
const conosur = 'BANCO CONOSUR';
const copeuch = 'BANCO COPEUCH';

export const BANK_OPTIONS = [
  {
    name: chileBank,
    id: chileBank,
  },
  {
    name: internationalBank,
    id: internationalBank,
  },
  {
    name: continentalBank,
    id: continentalBank,
  },
  {
    name: stateBank,
    id: stateBank,
  },
  {
    name: scotiabank,
    id: scotiabank,
  },
  {
    name: bci,
    id: bci,
  },
  {
    name: brasilBank,
    id: brasilBank,
  },
  {
    name: centralBank,
    id: centralBank,
  },
  {
    name: bice,
    id: bice,
  },
  {
    name: hsbc,
    id: hsbc,
  },
  {
    name: bankOfAmerica,
    id: bankOfAmerica,
  },
  {
    name: santander,
    id: santander,
  },
  {
    name: outsideBank,
    id: outsideBank,
  },
  {
    name: itau,
    id: itau,
  },
  {
    name: sudameris,
    id: sudameris,
  },
  {
    name: jpmorgan,
    id: jpmorgan,
  },
  {
    name: americanExpress,
    id: americanExpress,
  },
  {
    name: argentinaBank,
    id: argentinaBank,
  },
  {
    name: security,
    id: security,
  },
  {
    name: falabella,
    id: falabella,
  },
  {
    name: ripley,
    id: ripley,
  },
  {
    name: consorcio,
    id: consorcio,
  },
  {
    name: penta,
    id: penta,
  },
  {
    name: paris,
    id: paris,
  },
  {
    name: bbva,
    id: bbva,
  },
  {
    name: desarrollo,
    id: desarrollo,
  },
  {
    name: conosur,
    id: conosur,
  },
  {
    name: copeuch,
    id: copeuch,
  },
];

export const optionMapper = new Map([
  ['paymentMethod', OPTIONS_PAYMENT_METHODS],
  ['bank', BANK_OPTIONS],
]);

export const messageMapper = new Map([
  [
    ripleyCard,
    {
      msg: (
        <React.Fragment>
          Si tu solicitud es aprobada, la devolución de tu dinero se realizará
          en un plazo de <strong>2 días hábiles</strong>, contados desde la
          fecha en que se emita y notifique la <strong>nota de crédito</strong>.
        </React.Fragment>
      ),
      msgSmall: (
        <React.Fragment>
          Plazo de Devolución: <strong>2 días hábiles</strong>.
        </React.Fragment>
      ),
      severity: 'info',
    },
  ],
  [
    chek,
    {
      msg: (
        <React.Fragment>
          Debes revisar si cuentas con el suficiente cupo para que podamos
          realizar la devolución de tu dinero. La reversa se realizará en un
          plazo de <strong>1 día hábil</strong>.
        </React.Fragment>
      ),
      msgSmall: (
        <React.Fragment>
          Plazo de Devolución: <strong>1 día hábil</strong>.
        </React.Fragment>
      ),
      severity: 'alert',
    },
  ],
  [
    creditCard,
    {
      msg: (
        <React.Fragment>
          Si tu solicitud es aprobada, la devolución de tu dinero se realizará
          en un plazo de <strong>3 a 5 días hábiles</strong>, contados desde la
          fecha en que se emita y notifique la <strong>nota de crédito</strong>.
        </React.Fragment>
      ),
      msgSmall: (
        <React.Fragment>
          Plazo de Devolución: <strong>3 a 5 días hábiles</strong>.
        </React.Fragment>
      ),
      severity: 'info',
    },
  ],
  [
    debitCard,
    {
      msg: (
        <React.Fragment>
          Si tu solicitud es aprobada, la devolución de tu dinero se realizará
          en un plazo de <strong>3 a 5 días hábiles</strong>, contados desde la
          fecha en que se emita y notifique la <strong>nota de crédito</strong>.
        </React.Fragment>
      ),
      msgSmall: (
        <React.Fragment>
          Plazo de Devolución: <strong>3 a 5 días hábiles</strong>.
        </React.Fragment>
      ),
      severity: 'info',
    },
  ],
]);
